import { all } from 'redux-saga/effects';

import authSaga from 'store/auth/saga';
import bookingTimeSlotSaga from 'store/booking/saga';
import accountSaga from 'store/account/saga';
import thankYouSaga from 'store/thankYou/saga';
import onlineServiceSaga from 'store/onlineService/saga';
import preferredSiteSaga from 'store/preferredSite/saga';
import viewBookingsSaga from 'store/viewBooking/saga';

export default function* rootSaga() {
  yield all([
    authSaga(),
    bookingTimeSlotSaga(),
    accountSaga(),
    thankYouSaga(),
    onlineServiceSaga(),
    preferredSiteSaga(),
    viewBookingsSaga(),
  ]);
}
